<template>
  <w-dialog :show="show"
            show-close
            :wallStyle="{zIndex: 1009}"
            footer-style="padding-bottom: 24px;border-top: 0;"
            box-style="width: 600px;"
            title="标签维护"
            @close="cancelHandle">
    <div>
      <table class="group-tag-table" width="100%" cellspacing="0" cellpadding="0" style="margin-top: 0;">
        <tr>
          <td class="group-tag-td"><p class="group-tag-namep">添加标签：</p></td>
          <td height="70">
            <p class="group-tag-tip" :class="errorText !== '' ? 'error' : ''">{{errorText !== '' ? errorText : '标签最多3个，标签之间可用空格、顿号、逗号隔开'}}</p>
            <div class="group-tag-inputbox">
              <!--<input type="text" v-model="tagData"  class="group-tag-input" placeholder="示例：业主，工程类型，业务阶段...">-->
              <!--<a class="group-tag-addbtn"  @click="tagHandel(tagData)"></a>-->
              <w-input size="small" placeholder="示例：业主，工程类型，业务阶段..." v-model="tagData">
                <w-button size="small" @click="tagHandel(tagData)" slot="append" icon="r2-icon-content_add"></w-button>
              </w-input>
            </div>
          </td>
        </tr>
        <tr>
          <td class="group-tag-td"><p class="group-tag-namep2">已添加的标签：</p></td>
          <td height="70">
            <!--<w-tag v-for="(item,index) in labelList" :key="index" size="small" class="margin-right-10" closable @close="delLabl(index)">{{item}}</w-tag>-->
            <ul class="addtag-list">
              <li v-for="(item,index) in labelList" :key="index" class="border-radius-4">{{item}}<i @click="delLabl(index)"></i></li>
            </ul>
          </td>
        </tr>
      </table>
      <div class="tag-hisbox">
        <p>最近使用的标签</p>
        <ul class="taghistory-list">
          <li v-for="(item,index) in usedLabels" :key="item+''+index" @click="tagHandelUsed(item)">{{item}}</li>
        </ul>
      </div>
      <div class="tag-hinttext">注：可不添加标签</div>
    </div>
    <template slot="footer">
      <w-button type="primary" size="small" @click="submitHandle">确认</w-button>
      <w-button type="minor"  @click="cancelHandle">取消</w-button>
    </template>
  </w-dialog>
</template>
<script>
import CombinationService from '@/assets/service/combination'
// import {capitalize} from '@/assets/utils';
// import {mapState} from 'vuex';
export default {
  name: 'DialogEditLabel',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    saveError: {
      type: String,
      default: ''
    },
    saveErrorIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      labelList: [],
      usedLabels: [],
      errorText: '',
      tagData: ''
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      let parameter = {}
      CombinationService.getUsedLabels(parameter).then((res) => {
        if (+res.code === 200){
          this.usedLabels = res.data
        }
      })
    },
    trimData (text){
      return text.replace(/(^\s*)|(\s*$)/g, '')
    },
    delLabl (index){
      this.labelList.splice(index, 1)
      if (this.saveError && this.errorText === this.saveError) {
        this.errorText = ''
      }
    },
    tagHandelUsed (inputtext){
      if (this.labelList.length >= 3){
        this.errorText = '当前标签数不能超过3个'
        return
      }
      if (this.labelList.indexOf(this.trimData(inputtext)) === -1){
        this.labelList.push(this.trimData(inputtext))
      }
    },
    tagHandel (inputtext){
      let tagary = []
      let tagary1 = []
      let tagary2 = []
      let tagary3 = []
      inputtext = inputtext.split(' ')
      for (let i = 0;i < inputtext.length;i++){
        tagary = tagary.concat(inputtext[i].split(','))
      }
      for (let i = 0;i < tagary.length;i++){
        tagary1 = tagary1.concat(tagary[i].split('，'))
      }
      for (let i = 0;i < tagary1.length;i++){
        tagary2 = tagary2.concat(tagary1[i].split('、'))
      }
      for (let i = 0;i < tagary2.length;i++){
        tagary3 = tagary3.concat(tagary2[i].split('\n'))
      }
      tagary3 = this.removeDuplicatedItem(tagary3)
      if (tagary3.length + this.labelList.length > 3){
        this.errorText = '当前标签数不能超过3个'
        return
      }

      let tagVerification = true
      for (let i = 0;i < tagary3.length;i++){
        if (tagary3[i].length > 10){
          tagVerification = false
        }
      }
      if (!tagVerification){
        this.errorText = '输入内容不超过10个字'
        return
      }
      for (let i = 0;i < tagary3.length;i++){
        this.usedLabels.map((item) => {
          if (this.trimData(item) === this.trimData(tagary3[i])){
            tagVerification = false
          }
        })
        if (tagVerification){
          if (this.labelList.indexOf(this.trimData(tagary3[i])) === -1){
            this.labelList.push(this.trimData(tagary3[i]))
          }
        }
        tagVerification = true
      }
      this.tagData = ''
      this.errorText = ''
    },
    removeDuplicatedItem (ar) {
      var tmp = {}
      var ret = []
      for (var i = 0, j = ar.length; i < j; i++) {
        if (ar[i] !== ''){
          if (!tmp[ar[i]]) {
            tmp[ar[i]] = 1
            ret.push(ar[i])
          }
        }

      }
      return ret
    },
    // 确定
    submitHandle () {
      this.$emit('submit', this.editData.id, this.labelList)
    },
    // 取消
    cancelHandle () {
      this.$emit('cancel')
    }
  },
  watch: {
    'show': function () {
      this.initData()
      console.log(this.editData)
      if (this.editData.tagLabels){
        let label = this.editData.tagLabels
        this.labelList = label.split('、')
      } else {
        this.labelList = []
      }
      this.tagData = ''
      this.errorText = ''
    },
    'saveErrorIndex': function () {
      this.errorText = this.saveError
    }
  }
}
</script>
<style lang="less" type="text/less">
  .group-tag-table{
    width:100%;
    margin-top: 26px;
    font-size: 12px;
    color: #222222;
  }
  .group-tag-table tr td{
    vertical-align: top;
  }
  .group-tag-td{
    width: 90px;
    text-align: right;
    padding-right:10px;
  }
  .group-tag-namep{
    padding-top:31px;
  }
  .group-tag-input{
    width: 370px;
    border:1px solid #1a6dcd;
    height:28px;
    font-size:12px;
    color: #363636;
    padding:0px 5px;
    float: left;
  }
  .group-tag-tip{
    padding-bottom: 10px;
  }
  .group-tag-addbtn{
    float: left;
    margin-left:10px;
    width:50px;
    height: 30px;
    background: url("~@/assets/images/tag-add.png") no-repeat;
    cursor: pointer;
  }
  .group-tag-addbtn:hover{
    opacity: 0.8;
  }
  .addtag-list li{
    display: inline-block;
    padding:0px 24px 0px 10px;
    height:24px;
    line-height: 24px;
    border:1px solid #e3e5e2;
    margin-right:10px;
    margin-bottom:10px;
    position: relative;
    color: #1a6dcd;
  }
  .group-tag-namep2{
    padding-top:4px;
  }
  .addtag-list li i{
    width:20px;
    height:20px;
    background:  url("~@/assets/images/tag-close.png") no-repeat center center;
    position: absolute;
    right:2px;
    top:2px;
    cursor: pointer;
  }
  .tag-hisbox{
    padding: 16px 6px 5px;
    border-top:1px solid #cccccc;
    font-size:12px;
    color: #222222;
  }
  .tag-hisbox p{
    padding-bottom: 8px;
  }
  .taghistory-list li{
    display: inline-block;
    padding:0px 10px 0px 10px;
    height:24px;
    line-height: 24px;
    border:1px solid #e3e5e2;
    margin-right:8px;
    margin-top:8px;
    cursor: pointer;
    position: relative;
  }
  .taghistory-list li:hover{
    border:1px solid #1a6dcd;
    background: #f1f7ff;
  }
  .dialog .dialog-foot.tag-dialog-foot{
    border-top:1px solid #cccccc !important;
    position: relative;
  }
  .group-tag-tip.error{
    color: red;
  }
  .tag-hinttext{
    font-size: 14px;
    line-height: 32px;
    color: #222222;
    padding-top: 22px;
    padding-left: 20px;
    position: absolute;
    left: 0px;
    bottom: 24px;
  }
</style>
